import * as React from 'react';
import PropTypes from 'prop-types';
import {
    withStyles, Button, Typography,
} from '@material-ui/core';
import { getTranslate, Translate } from 'react-localize-redux';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import urls from '../../app/urls';
import studentsImage from '../../common/image/icon_elever.png';
import StudentLine from './components/StudentLine';
import ProgramInformation from './components/ProgramInformation';
import { Image } from '../../youwell-common/components';
import VimoIntroTour from './components/VimoIntroTour';

const styles = theme => ({
    root: {
    },
    content: {
        padding: theme.spacing(4),

        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1),
        },
    },
    heading: {
        marginLeft: theme.spacing(3),
    },
    programContent: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(8),

        [theme.breakpoints.down('xs')]: {
            marginBottom: theme.spacing(12),
        },
    },
    divider: {
        boxShadow: theme.shadows[3],
        margin: theme.spacing(0, -4, 4, -4),
        height: 1,
        position: 'relative',

        [theme.breakpoints.down('xs')]: {
            margin: theme.spacing(0, 0, 4, 0),
        },
    },
    studentsImage: {
        position: 'absolute',
        top: -94,
        left: 60,
        width: 150,
    },
    students: {
    },
    noStudentsDescription: {
        padding: theme.spacing(4),
    },
    topLine: {
        display: 'flex',
        alignItems: 'center',
    },
    flex: {
        flex: '1 1 auto',
    },
    studentList: {
        marginTop: theme.spacing(2),
    },
    link: {
        background: theme.colors.blue1,
        color: theme.palette.common.white,
        padding: theme.spacing(2),
        margin: `${theme.spacing(4)}px 0`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    icon: {
        marginLeft: theme.spacing(1),
    },
    noLicense: {
        marginTop: theme.spacing(4),
        background: theme.palette.grey[50],
        padding: theme.spacing(1),
        border: theme.borders.normal,
        color: theme.colors.blue2,
        display: 'block',
        textAlign: 'center',
    },
});

const Dashboard = ({
    classes, translate, profileData, studentList,
}) => {
    const canEdit = profileData?.userAccess?.editPatients;
    const hasLicense = profileData?.license;

    return (
        <div className={classes.root}>
            <VimoIntroTour />

            {profileData && !hasLicense && (
                <Typography variant="subtitle1" className={classes.noLicense}>
                    {translate('dashboard.noLicenseNotification')}
                </Typography>
            )}

            <div className={classes.content}>
                <Typography variant="h5" color="secondary" className={classes.heading}>
                    {translate('dashboard.content')}
                </Typography>

                <ProgramInformation className={classes.programContent} hasLicense={hasLicense} />

                <div className={classes.divider}>
                    <Image src={studentsImage} className={classes.studentsImage} />
                </div>

                <div className={classes.students}>
                    <div className={classes.topLine}>
                        <Typography variant="h5" color="secondary" className={classes.heading}>
                            {translate('dashboard.students')}
                        </Typography>
                        <div className={classes.flex} />

                        {canEdit && (
                            <Button
                                to={urls.inside.student.new}
                                component={Link}
                                variant="outlined"
                                color="primary"
                            >
                                <Translate id="dashboard.createNewStudent" />
                            </Button>
                        )}
                    </div>
                    <div className={classes.studentList}>
                        {studentList && studentList.length > 0 ? studentList.map(student => (
                            <StudentLine studentData={student} key={student.id} hasLicense={hasLicense} />
                        )) : (
                            <Typography variant="subtitle1" className={classes.noStudentsDescription}>
                                {translate('dashboard.noStudentsDescription')}
                            </Typography>
                        )}
                    </div>
                </div>
            </div>

        </div>
    );
};

Dashboard.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    profileData: PropTypes.object,
    studentList: PropTypes.array,
};

Dashboard.defaultProps = {
    profileData: null,
    studentList: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    profileData: state.auth.profileData,
    studentList: state.patient.list,
});

export default connect(mapStateToProps)(withStyles(styles)(Dashboard));
